import $ from 'jquery';

$(function () {
  $('.custom-select').selectric();
});
